var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c("InputFile", {
        attrs: { accept: ".csv,.txt", "file-name": _vm.fileName },
        on: { change: _vm.loadTextFromFile }
      }),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "t",
            rawName: "v-t",
            value: "FILE_MAXIMUM_SIZE",
            expression: "'FILE_MAXIMUM_SIZE'"
          }
        ],
        staticClass: "text-muted"
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { title: _vm.$i18n.t("FILE_TOO_BIG_ERROR_TITLE") },
          model: {
            value: _vm.openModal,
            callback: function($$v) {
              _vm.openModal = $$v
            },
            expression: "openModal"
          }
        },
        [
          _c("p", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "FILE_TOO_BIG_ERROR",
                expression: "'FILE_TOO_BIG_ERROR'"
              }
            ]
          }),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("btn", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "CANCEL",
                    expression: "'CANCEL'"
                  }
                ],
                on: {
                  click: function($event) {
                    _vm.openModal = false
                  }
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }